<script setup>
import { computed } from 'vue';

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  size: {
    type: Number,
    default: null,
  },
});

const computedStyles = computed(() => {
  const styles = {};
  if (props.size) {
    styles['font-size'] = `${props.size}px`;
  }

  return styles;
});
</script>

<template>
  <div class="ui-caret">
    <i 
      class="fas fa-angle-down"
      :class="[
        'ui-caret__icon',
        {'ui-caret__icon_open': props.open}
      ]"
      :style="computedStyles"
    />
  </div>
</template>

<style lang="scss">
.ui-caret {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;

  &__icon {
    color: var(--color-color-disable);
    transform: rotate(0deg);
    transition: var(--el-transition-duration);
    font-size: 12px;
    
    &_open {
      transform: rotate(180deg);
    }
  }
}
</style>